/**
 * Utilitário para obter a URL da API baseada no ambiente
 * Usa a mesma lógica do api.js para consistência
 */

const getApiUrl = () => {
  const hostname = window.location.hostname;

  const isDevelopment =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("ngrok") ||
    process.env.REACT_APP_FORCE_DEV === "true";

  const apiUrl = isDevelopment
    ? process.env.REACT_APP_SERVER_URL_DEV
    : process.env.REACT_APP_SERVER_URL_PROD;

  console.log(`[getApiUrl] Ambiente: ${isDevelopment ? 'DESENVOLVIMENTO' : 'PRODUÇÃO'}, URL: ${apiUrl}`);

  return apiUrl;
};

export default getApiUrl;
